import { __extends } from "tslib";
import { MDCRipple } from '@material/ripple';
import { addClass, getShadowElement, removeClass, removeElement, walkUpUntil } from '@tyler-components-web/core';
import { BaseAdapter } from '../../core/adapters/base-adapter';
import { elementFromHTML, toggleClass } from '../../core/utils';
import { CHIP_SET_CONSTANTS } from '../chip-set/chip-set-constants';
import { CHIP_CONSTANTS } from './chip-constants';
import { ICON_CONSTANTS } from '../../icon';
var checkmarkTemplate = require('./chip-checkmark.html');
var ChipAdapter = /** @class */ (function (_super) {
    __extends(ChipAdapter, _super);
    function ChipAdapter(component) {
        var _this = _super.call(this, component) || this;
        _this._buttonElement = getShadowElement(_this._component, CHIP_CONSTANTS.selectors.BUTTON);
        _this._leadingSlotElement = getShadowElement(_this._component, 'slot[name=leading]');
        return _this;
    }
    ChipAdapter.prototype.addButtonListener = function (type, listener) {
        this._buttonElement.addEventListener(type, listener);
    };
    ChipAdapter.prototype.removeButtonListener = function (type, listener) {
        this._buttonElement.removeEventListener(type, listener);
    };
    ChipAdapter.prototype.initializeRipple = function () {
        return new MDCRipple(this._buttonElement);
    };
    ChipAdapter.prototype.clearTypeClass = function () {
        removeClass([CHIP_CONSTANTS.classes.ACTION, CHIP_CONSTANTS.classes.CHOICE, CHIP_CONSTANTS.classes.FILTER, CHIP_CONSTANTS.classes.INPUT], this._buttonElement);
    };
    ChipAdapter.prototype.addRootClass = function (className) {
        this._buttonElement.classList.add(className);
    };
    ChipAdapter.prototype.removeRootClass = function (name) {
        this._buttonElement.classList.remove(name);
    };
    ChipAdapter.prototype.setCheckmarkVisibility = function (isVisible) {
        if (isVisible) {
            if (!this._checkmarkElement) {
                this._checkmarkElement = elementFromHTML(checkmarkTemplate);
            }
            this._buttonElement.insertBefore(this._checkmarkElement, this._buttonElement.firstChild);
        }
        else if (this._checkmarkElement && this._checkmarkElement.isConnected) {
            removeElement(this._checkmarkElement);
        }
    };
    ChipAdapter.prototype.setSelected = function (value) {
        toggleClass(this._buttonElement, value, CHIP_CONSTANTS.classes.SELECTED);
    };
    ChipAdapter.prototype.setDisabled = function (value) {
        this._buttonElement.disabled = value;
    };
    ChipAdapter.prototype.setDense = function (value) {
        toggleClass(this._buttonElement, value, CHIP_CONSTANTS.classes.DENSE);
    };
    ChipAdapter.prototype.setDeleteButtonVisibility = function (isVisible, listener) {
        if (isVisible) {
            if (!this._deleteButton) {
                this._deleteButton = this._createDeleteButton(listener);
            }
            if (!this._deleteButtonTouchTarget) {
                this._deleteButtonTouchTarget = this._createDeleteButtonTouchTarget(listener);
            }
            this._deleteButton.appendChild(this._deleteButtonTouchTarget);
            this._buttonElement.appendChild(this._deleteButton);
        }
        else {
            if (this._deleteButtonTouchTarget) {
                removeElement(this._deleteButtonTouchTarget);
            }
            if (this._deleteButton) {
                removeElement(this._deleteButton);
            }
        }
    };
    ChipAdapter.prototype.setLeadingSlotVisibility = function (isVisible) {
        toggleClass(this._leadingSlotElement, !isVisible, CHIP_CONSTANTS.classes.LEADING_HIDDEN);
    };
    ChipAdapter.prototype.getChipSetState = function () {
        var state = null;
        var chipSet = walkUpUntil(this._component, function (node) { return node && node.nodeName === CHIP_SET_CONSTANTS.elementName.toUpperCase(); });
        if (chipSet) {
            state = {
                type: chipSet.type,
                disabled: chipSet.disabled,
                dense: chipSet.dense
            };
        }
        return state;
    };
    ChipAdapter.prototype._createDeleteButton = function (listener) {
        var el = document.createElement(ICON_CONSTANTS.elementName);
        el.name = 'cancel';
        el.tabIndex = 0;
        el.setAttribute('aria-label', 'Delete');
        el.setAttribute('role', 'button');
        addClass([CHIP_CONSTANTS.classes.DELETE_BUTTON], el);
        el.addEventListener('keydown', listener);
        return el;
    };
    ChipAdapter.prototype._createDeleteButtonTouchTarget = function (listener) {
        var el = document.createElement('div');
        addClass(CHIP_CONSTANTS.classes.DELETE_BUTTON_TOUCH_TARGET, el);
        el.addEventListener('keydown', listener);
        el.addEventListener('click', listener);
        return el;
    };
    ChipAdapter.prototype.setFocus = function () {
        this._buttonElement.focus();
    };
    return ChipAdapter;
}(BaseAdapter));
export { ChipAdapter };
